// Clean bracket at the end of ISO formats.
// Example "2026-05-30T00:23:09.807+0000[UTC]" -> "2026-05-30T00:23:09.807+0000" 
export const cleanDateTimeBrackets = (d?: string) => {
  return d.replace(/\[.*?\]$/, '');
}

export function isValidDateTime(str) {
  const date = new Date(str);
  return !Number.isNaN(date.getTime());
}

export const isMatchingComment = (
  item: Accelerate.ActivityItem,
  lookupType: CQA.CQAComment['lookup_type']
) =>
  'lookup_type' in item && item.lookup_type === lookupType;

// Feedback is only shown to the CQA coder while the grading task is in progress (IN_CQA)
// and the feedback entry is time stamped after the grader work item was reverted.
export const applyCQAFilters = (activity: ReadonlyArray<Accelerate.ActivityItem>, lookupType: CQA.CQAComment['lookup_type'], updatedDate: string) => {
  if (!activity
    || activity.length === 0
    || !lookupType
    || !isValidDateTime(updatedDate)

  ) {
    return [];
  }

  return activity
    .filter((item): item is CQA.CQAComment => isMatchingComment(item, lookupType))
    .filter((item) => new Date(cleanDateTimeBrackets(item.created_date)) > new Date(updatedDate))
    .sort((itemA, itemB) => (itemA.created_date < itemB.created_date ? 1 : -1))
};